<template>
  <div>
    <v-bottom-sheet v-model="menuVisibile">
      <v-list two-line>
        <v-list-tile @click="setAzione('scorte')">
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>Scorte</strong>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="setAzione('forzatura')">
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>Forzatura articolo</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-on:click="setAzione('elimina')">
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>Elimina evasione</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-on:click="setAzione('ricevi')" v-if="getLink=='/evasione'">
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>Ricevi</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>

    <!-- Bottone azioni -->
    <v-btn
      color="gray"
      dark
      fixed
      bottom
      left
      fab
      @click.stop="menuVisibile = true"
      class="float-button"
    >
      <v-icon style="padding-top:15px;">settings</v-icon>
    </v-btn>

    <!-- Dialog Scorte-->
    <dialog-scorte :active.sync="apriScorte"></dialog-scorte>
  </div>
</template>
<script>
import DialogScorte from "@/components/dialog/DialogScorte";

export default {
  components: {
    DialogScorte
  },

  data: () => ({
    apriScorte: false,
    menuVisibile: false
  }),

  methods: {
    setAzione(azione) {
      this.menuVisibile = false;

      if (azione == "scorte") {
        this.apriScorte = true;
      } else {
        this.$store.commit("app/setAzione", azione);
      }
    }
  },
  computed: {
    getLink() {
      return this.$store.getters["app/getLink"];
    }
  }
};
</script>

<style scoped>
.float-button {
  bottom: 36px !important;
}
</style>

